module.exports = __webpack_public_path__ + "static/media/info-icon-small.96048533.svg";